import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/realtorsinLandingPage/node_modules/next/dist/client/app-dir/link.js");
